import { useState } from "react";
import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { Target, ClockCounterClockwise } from "@phosphor-icons/react";

export default function GoalSetting() {
  const { lists, nameMap } = useLookups();
  const [rows, setRows] = useState([]);

  const active = rows.filter((g) => g.status === "Active").length;
  const achieved = rows.filter((g) => g.status === "Achieved").length;
  const history = rows.filter((g) => g.status !== "Active").length;

  const header = (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="rounded-lg bg-navy text-white p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-gold/20 flex items-center justify-center"><Target size={22} weight="fill" className="text-gold" /></div>
        <div><div className="font-heading text-2xl font-extrabold">{active}</div><div className="text-xs text-slate-300">Active Goals</div></div>
      </div>
      <div className="rounded-lg bg-white border border-slate-200 p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-emerald/10 flex items-center justify-center"><Target size={22} weight="fill" className="text-emerald" /></div>
        <div><div className="font-heading text-2xl font-extrabold text-emerald">{achieved}</div><div className="text-xs text-slate">Achieved</div></div>
      </div>
      <div className="rounded-lg bg-white border border-slate-200 p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-slate/10 flex items-center justify-center"><ClockCounterClockwise size={22} weight="fill" className="text-slate" /></div>
        <div><div className="font-heading text-2xl font-extrabold text-navy">{history}</div><div className="text-xs text-slate">In Goal History</div></div>
      </div>
    </div>
  );

  return (
    <div data-testid="goals-page" className="space-y-4">
      <p className="text-sm text-slate max-w-3xl">
        Create and manage every target here. Goals set on this page automatically populate the live
        <span className="text-navy font-semibold"> Dashboard KPI Scorecard</span> and the
        <span className="text-navy font-semibold"> Monthly Review</span> — set once, flows everywhere.
      </p>
      <CrudTable resource="goals" config={MODULES.goals} lists={lists} nameMap={nameMap} onData={setRows} extraHeader={header} />
    </div>
  );
}
